import React, { useState } from 'react';
import { colors } from '../../config/constants';
import { ResultProps } from '../../screens/ManualSearch/ManualSearch';

const List = (props: any) => {
  const {
    state,
    clickHandler,
    searchHandler,
    loadMore,
    pageLimit,
    totalCount,
    error,
  } = props;
  const [itemClick, setItemClick] = useState(false);
  const [info, setInfo] = useState<{ name: string; id: string }>({
    name: 'Select category',
    id: '',
  });

  const handleChage = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    searchHandler && searchHandler(e);
  };

  return (
    <div className="relative" data-testid="list-wrapper">
      <div className={`${colors.primaryText} ml-1 mb-1 text-sm font-semibold`}>
        {'Category'}
      </div>
      <div
        data-testid="list-name"
        onClick={() => setItemClick(true)}
        className={`cursor-pointer w-full lg:w-[250px] xl:w-[300px] h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1]`}
      >
        {info.name.length < 20 ? info.name : `${info.name.substring(0, 30)}...`}
      </div>
      <div className="text-[red] text-sm">{error}</div>
      {itemClick && (
        <div className="absolute bg-white p-2 w-full lg:w-[250px] xl:w-[300px] top-0 max-h-[300px] overflow-scroll z-[50]">
          <div className="mb-2">
            <input
              data-testid="search-input"
              className="h-6 border p-1 rounded-full outline-none w-full focus:border-[#64CCC5] text-[13px] pl-2"
              placeholder={'Please search category'}
              value={state.searchKeyword}
              autoComplete="off"
              onChange={(e) => handleChage(e)}
            />
          </div>
          <div>
            {state.length > 0 ? (
              <>
                {state?.map((item: ResultProps, index: number) => {
                  return (
                    <div
                      data-testid={`list-item-${index}`}
                      onClick={() => {
                        setItemClick(false);
                        setInfo({ ...info, name: item.name, id: item.id });
                        clickHandler && clickHandler(item);
                      }}
                      key={index}
                      className={`cursor-pointer p-1 w-full hover:bg-slate-200 border-b text-[13px] ${colors.primaryText}`}
                    >
                      {item.name}
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="text-sm" data-testid="list-no-data">
                No result found!
              </div>
            )}
          </div>
          {totalCount >= pageLimit && state.length > 0 && (
            <div
              className={`shadow-sm cursor-pointer mt-2 text-sm border border-sky-500 flex items-center justify-center text-sky-500`}
              onClick={() => loadMore()}
            >
              Load More
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default List;
